import React, { useState, useEffect } from 'react';
import axios, { encryptData } from '../Axiosinstance';
import { removeBracketedText } from '../Axiosinstance';
import { useNavigate } from 'react-router-dom';
import dayjs from 'dayjs';
import { Card, CardContent, Box, Typography, Grid, Button, List, ListItem, Paper, TableContainer, Table, TableHead, TableBody, TableRow, TableCell,InputAdornment, IconButton, TextField, Select, MenuItem, FormControl, InputLabel  } from "@mui/material";
import { CheckCircle } from "@mui/icons-material";
import ClearIcon from '@mui/icons-material/Clear';

import Loader from '../Loader';
const BatchSummary = () => {
  const [batchSummary, setBatchSummary] = useState([]);
  const navigate = useNavigate();
  const [initialModulus, setInitialModulus] = useState(1);

  const [searchText, setSearchText] = useState("");
  const [filterType, setFilterType] = useState('All');
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    setLoading(true); // Start loading
    axios.get('/batch-summary')
      .then(response => {
        setBatchSummary(response.data);
        console.log(response.data);
      })
      .catch(error => console.error('Error fetching batch summary:', error))
      .finally(() => {
        setLoading(false); // Stop loading, even if error
      });
  }, []);
  const filteredBatches = batchSummary.filter((batch) => {
    const matchesSearch = batch.course.toLowerCase().includes(searchText.toLowerCase());
    const matchesFilter = filterType === 'All' || batch.type === filterType;
    return matchesSearch && matchesFilter;
  });

  // const handleDateChange = (batch) => {

  //   const newDate = dayjs(); // Create dayjs object from the new date
  //   const oldDate = dayjs(); // Get the current date

  //   console.log("Current Date:", oldDate.format('YYYY-MM-DD'));
  //   console.log("New Date:", newDate.format('YYYY-MM-DD'));

  //   // Calculate the difference in months between the old and new dates
  //   let monthDifference = newDate.month() - oldDate.month(); // Difference in months, taking months of the year into account

  //   if (newDate.year() !== oldDate.year()) {
  //     // Adjust for different years (e.g., from Dec to Jan)
  //     monthDifference += (newDate.year() - oldDate.year()) * 12;
  //   }

  //   console.log("Month Difference:", monthDifference);

  //   // Determine the increment based on the type
  //   let increment = 0;
  //   if (batch.type === 'diploma') {
  //     increment = Math.floor(monthDifference / 2); // Increment by 1 for every 2 months
  //     console.log("Diploma Course - Increment:", increment);
  //   }
  //   else if (batch.type === 'advance_diploma') {
  //     increment = monthDifference; // Increment by 1 for every month
  //     console.log("Advance Diploma Course - Increment:", increment);
  //   }

  //   // Calculate the new modulus value based on the increment
  //   let newModulus = initialModulus + increment;
  //   console.log("New Modulus Before Ensuring Range:", newModulus);

  //   // Ensure the modulus value stays between 1 and 6
  //   newModulus = ((newModulus - 1) % 6 + 6) % 6 + 1; // Wrap around to keep it between 1 and 6
  //   console.log("New Modulus After Ensuring Range:", newModulus);

  //   // Determine the first Saturday and Sunday of the month
  //   const firstSaturday = newDate.date(1).day(6); // First Saturday
  //   const firstSunday = newDate.date(1).day(7);   // First Sunday

  //   console.log("First Saturday of the Month:", firstSaturday.format('YYYY-MM-DD'));
  //   console.log("First Sunday of the Month:", firstSunday.format('YYYY-MM-DD'));

  //   if (batch.type === 'diploma') {
  //     const isEvenMonth = (newDate.month() + 1) % 2 === 0; // Check if the month is even
  //     console.log("Is Even Month:", isEvenMonth);

  //     if (isEvenMonth) {
  //       // For even months, just add 1 to newModulus
  //       newModulus += 1;
  //       console.log("Diploma - Even Month: Adjusting Modulus by adding 1.");
  //     } else {
  //       // For odd months, check if the new date is after the first Saturday or Sunday
  //       if (newDate.isAfter(firstSaturday) || newDate.isAfter(firstSunday)) {
  //         newModulus += 1;
  //         console.log("Diploma - Odd Month: Adjusting Modulus by adding 1 after the first Saturday/Sunday.");
  //       }
  //     }
  //   } else if (batch.type === 'advance_diploma') {
  //     // Check if the new date is after the first Sunday
  //     if (newDate.isAfter(firstSunday)) {
  //       newModulus += 1;
  //       console.log("Advance Diploma - Adjusting Modulus by adding 1.");
  //     }
  //   }

  //   // Ensure modulus value stays within the 1-6 range after adjustments
  //   newModulus = ((newModulus - 1) % 6 + 6) % 6 + 1;

  //   setInitialModulus(newModulus);
  //   console.log("newModulus", newModulus)
  //   return newModulus;
  // };


  const handleDateChange = (batch) => {

    if (batch?.status) {

      console.log("Batch is active. Using current module:", batch?.currentModule);
      return batch.currentModule; // Exit function
    }

    const newDate = dayjs(); // Create dayjs object from the new date
    const oldDate = dayjs(); // Get the current date

    // const { value } = event.target;
    // console.log("Selected Enrollment Date:", value, "| Type:", typeof value);

    // const newDate = dayjs(value);
    // const oldDate = dayjs('2025-01-14');

    console.log("Current Date:", oldDate.format('YYYY-MM-DD'));
    console.log("New Date:", newDate.format('YYYY-MM-DD'));
    console.log("New Date Valid?", newDate.isValid());

    // Check for invalid date handling
    if (!newDate.isValid()) {
      console.error("Invalid newDate detected. Check input format.");
      return;
    }

    let monthDifference = newDate.month() - oldDate.month();
    if (newDate.year() !== oldDate.year()) {
      monthDifference += (newDate.year() - oldDate.year()) * 12;
    }
    console.log("Month Difference:", monthDifference);

    console.log("Form Data Type:", batch?.type);

    let increment = 0;
    if (batch?.type === 'diploma') {
      // Check if the oldDate month is odd or even
      if (oldDate.month() % 2 === 1) {
        // For odd months, increment by 1 for every odd month difference
        increment = Math.floor((monthDifference + 1) / 2);
      } else {
        // For even months, increment by 1 for every 2 months
        increment = Math.floor(monthDifference / 2);
      }
      console.log("Diploma Course - Increment:", increment);
    } else if (batch?.type === 'advance_diploma') {
      // For advance diploma, increment by the full month difference
      increment = monthDifference;
      console.log("Advance Diploma Course - Increment:", increment);
    } else {
      console.warn("Unknown formData.type detected:", batch?.type);
    }

    console.log("Initial Modulus:", batch.currentModule);


    // Adjust the modulus based on the increment
    let newModulus = batch.currentModule + increment;
    newModulus = ((newModulus - 1) % 6 + 6) % 6 + 1; // Ensure modulus stays within 1-6
    console.log("New Modulus After Adjustments:", newModulus);

    const firstDayOfMonth = newDate.startOf('month');

    // First Saturday
    let firstSaturday = firstDayOfMonth.day(6);
    if (firstSaturday.isBefore(firstDayOfMonth)) {
      firstSaturday = firstSaturday.add(7, 'days');
    }

    // First Sunday
    let firstSunday = firstDayOfMonth.day(0);
    if (firstSunday.isBefore(firstDayOfMonth)) {
      firstSunday = firstSunday.add(7, 'days');
    }

    console.log("First Saturday of the Month:", firstSaturday.format('YYYY-MM-DD'));
    console.log("First Sunday of the Month:", firstSunday.format('YYYY-MM-DD'));

    console.log("before updating  New Modulus:", newModulus);

    if (batch?.type === 'diploma') {
      const isEvenMonth = (newDate.month() + 1) % 2 === 0;
      console.log("Is Even Month:", isEvenMonth);

      if (isEvenMonth) {
        newModulus += 1;
        console.log("Diploma - Even Month: Adjusting Modulus by adding 1.");
      } else {
        if (newDate.isAfter(firstSaturday) || newDate.isAfter(firstSunday)) {
          newModulus += 1;
          console.log("Diploma - Odd Month: Adjusting Modulus by adding 1 after first Saturday/Sunday.");
        }
      }
    } else if (batch?.type === 'advance_diploma') {
      if (newDate.isAfter(firstSunday)) {
        newModulus += 1;
        console.log("Advance Diploma - Adjusting Modulus by adding 1.");
      }
    }

    newModulus = ((newModulus - 1) % 6 + 6) % 6 + 1;
    console.log("Final New Modulus:", newModulus);


    setInitialModulus(newModulus);
    console.log("newModulus", newModulus)
    return newModulus;
  };

  const getFirstSunday = (date) => {
    const firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
    const firstSunday = new Date(firstDay.setDate(firstDay.getDate() + (7 - firstDay.getDay()) % 7));
    return firstSunday;
  };

  const getLastSunday = (date) => {
    const lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);
    const lastSunday = new Date(lastDay.setDate(lastDay.getDate() - (lastDay.getDay() % 7)));
    return lastSunday;
  };

  const getFirstSaturday = (date) => {
    const firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
    const firstSaturday = new Date(firstDay.setDate(firstDay.getDate() + (6 - firstDay.getDay()) % 7));
    return firstSaturday;
  };

  const handleRegistration = (batch) => {
    const newModulus = handleDateChange(batch);
    const tableData = generateTableData(batch.type);
    console.log("tableData", tableData);
    const selectedStartDate = tableData[0].startDate;
    const formattedDate = new Date().toISOString().split('T')[0];
    const type = batch.type;
    console.log("formattedDate", formattedDate);
    const encryptedModule = encodeURIComponent(encryptData(newModulus));
    const encryptedBatchId = (batch.id);
    const encryptedStartDate = encodeURIComponent(encryptData(formattedDate));
    const encryptedType = encodeURIComponent(encryptData(type));


    navigate(`/registration/${encryptedBatchId}`);
  };

  const generateTableData = (type) => {
    const currentDate = new Date();
    const tableData = [];

    const formatDate = (date) => {
      return date.toLocaleDateString('en-GB'); // This will format the date as DD/MM/YYYY
    };

    if (type === 'advance_diploma') {
      for (let i = 0; i < 3; i++) {
        const startOfMonth = new Date(currentDate.getFullYear(), currentDate.getMonth() + i + 1, 1);
        const firstSunday = getFirstSunday(startOfMonth);
        const endDate = new Date(firstSunday);
        endDate.setMonth(endDate.getMonth() + 6);
        endDate.setDate(endDate.getDate() - 1);
        tableData.push({
          startDate: formatDate(firstSunday),
          endDate: formatDate(endDate),
          registrationCloseDate: formatDate(new Date(firstSunday.setDate(firstSunday.getDate() - 1)))
        });
      }
    } else if (type === 'diploma') {
      for (let i = 1; i <= 6; i += 2) {
        const oddMonth = new Date(currentDate.getFullYear(), currentDate.getMonth() + i, 1);
        const firstSaturday = getFirstSaturday(oddMonth);
        const endDate = new Date(firstSaturday);
        endDate.setFullYear(endDate.getFullYear() + 1);
        endDate.setDate(endDate.getDate() - 1);
        tableData.push({
          startDate: formatDate(firstSaturday),
          endDate: formatDate(endDate),
          registrationCloseDate: formatDate(new Date(firstSaturday.setDate(firstSaturday.getDate() - 1)))
        });
      }
    }

    return tableData;
  };

  return (
    <Box
      sx={{
        padding: 4,
        background: "linear-gradient(to right, #bbdefb, #bbdefb)",
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
     
<Typography
    variant="h3"
    sx={{ fontWeight: "bold", color: "#0D47A1", textAlign: "center", mb: 4 }}
  >
    Course Summary
  </Typography>

  {/* Search Bar and Filter Type */}
  <Grid 
    container 
    spacing={2} 
    sx={{
      mb: 4, 
      justifyContent: "center",  // Center the search bar and filter
      flexDirection: { xs: "column", md: "row" },  // Stack vertically on mobile, horizontally on desktop
    }}
  >
    {/* Search Bar */}
    <Grid item xs={12} md={3}>
      <TextField
        label="Search Courses"
        variant="outlined"
        value={searchText}
        onChange={(e) => setSearchText(e.target.value)}
        fullWidth
        InputProps={{
          endAdornment: searchText && (
            <InputAdornment position="end">
              <IconButton onClick={() => setSearchText('')}>
                <ClearIcon />
              </IconButton>
            </InputAdornment>
          ),
        }}
        InputLabelProps={{
          style: { fontWeight: 'bold', color: '#0D47A1' },
        }}
        sx={{
          backgroundColor: "#fff",
          borderRadius: "12px",
          boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.2)",
        }}
      />
    </Grid>

    {/* Filter Type */}
    <Grid item xs={12} md={3}>
      <FormControl fullWidth
        sx={{
          backgroundColor: "#fff",
          borderRadius: "12px",
          boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.2)",
        }}
      >
        <InputLabel sx={{ fontWeight: 'bold', color: '#0D47A1' }}>Filter Type</InputLabel>
        <Select
          value={filterType}
          onChange={(e) => setFilterType(e.target.value)}
          label="Filter Type"
        >
          <MenuItem value="All">All</MenuItem>
          <MenuItem value="diploma">Diploma</MenuItem>
          <MenuItem value="advance_diploma">Advanced Diploma</MenuItem>
        </Select>
      </FormControl>
    </Grid>


  </Grid>

  {loading ? (
 <Box 
 sx={{ 
   display: 'flex', 
   justifyContent: 'center', 
   alignItems: 'center',  // vertically center also
  
 
 }}
>
 <Loader />
</Box>
) :filteredBatches.length > 0 ? (
        <Grid container spacing={4} justifyContent="center">
         {filteredBatches.map((batch) => (
            <Grid item xs={12} sm={6} md={4} key={batch.id}>
              <Card
                sx={{
                  borderRadius: "16px",
                  boxShadow: "0px 8px 16px rgba(0, 0, 0, 0.2)",
                  background: "rgba(255, 255, 255, 0.85)",
                  // backdropFilter: "blur(12px)",
                  padding: 3,
                  transition: "0.3s",
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-between",
                  '&:hover': {
                    transform: "scale(1.05)",
                    boxShadow: "0px 12px 20px rgba(0, 0, 0, 0.3)",
                  }
                }}
              >
                <CardContent>
                  <Typography
                    variant="h5"
                    gutterBottom
                    sx={{ fontWeight: "bold", color: "#1565C0", textAlign: "center" }}
                  >
                    {removeBracketedText(batch.course)}
                  </Typography>

                  <Typography
                    variant="subtitle1"
                    sx={{ fontWeight: "medium", color: "#424242", mb: 1, textAlign: "center" }}
                  >
                    Module Details
                  </Typography>

                  <List sx={{ padding: 0 }}>
                    {batch.moduleDetails.map((module) => (
                      <ListItem
                        key={module.id}
                        sx={{
                          fontSize: "14px",
                          color: "#444",
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        <CheckCircle sx={{ color: "#2E7D32", fontSize: "18px", mr: 1 }} />
                        {module.moduleName}
                      </ListItem>
                    ))}
                  </List>

                  <Button
                    variant="contained"
                    fullWidth
                    sx={{
                      mt: 2,
                      borderRadius: "12px",
                      fontWeight: "bold",
                      background: "linear-gradient(45deg, #1976D2, #42A5F5)",
                      '&:hover': { background: "linear-gradient(45deg, #0D47A1, #1565C0)" },
                    }}
                    onClick={() => handleRegistration(batch)}
                  >
                    Register Now
                  </Button>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      ) : (
        <Typography
          variant="h6"
          sx={{ textAlign: "center", mt: 4, color: "gray", fontStyle: "italic" }}
        >
           No Data Available 
        </Typography>
      )}
    </Box>
  );
};

export default BatchSummary;
